import './list_text_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['open']
  static targets = ['text', 'toggle']

  connect = (): void => {
    if (this.ellipsis) this.toggleTarget.remove()
  }

  toggle = (): void => {
    this.opened() ? this.close() : this.open()
  }

  open = (): void => {
    this.textTarget.classList.add(this.openClass)
    this.toggleTarget.innerHTML = 'Show less'
  }

  close = (): void => {
    this.textTarget.classList.remove(this.openClass)
    this.toggleTarget.innerHTML = 'Show more'
  }

  opened = (): boolean => {
    return this.textTarget.classList.contains(this.openClass)
  }

  get ellipsis (): boolean {
    return this.textTarget.scrollWidth <= this.textTarget.clientWidth
  }
}
